import { useEffect, useState } from "react";
import { Mail, MessageSquare } from "lucide-react";
import api from "@/lib/api";

export default function Communications() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => setRows((await api.get("/communications")).data))(); }, []);

  return (
    <div data-testid="communications-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Communications</h1>
        <p className="text-sm text-slate-500 mt-1">Every email and text you've sent to customers.</p>
      </div>

      <div className="mt-6 bg-white border border-slate-200 rounded-md">
        {rows.length === 0 && <div className="p-8 text-center text-slate-500 text-sm">No messages yet.</div>}
        <ul className="divide-y divide-slate-100">
          {rows.map((m) => (
            <li key={m.id} className="p-5 flex items-start gap-4" data-testid={`msg-${m.id}`}>
              <div className={`w-9 h-9 rounded-md flex items-center justify-center shrink-0 ${m.channel === "email" ? "bg-blue-50 text-blue-600 border border-blue-100" : "bg-emerald-50 text-emerald-600 border border-emerald-100"}`}>
                {m.channel === "email" ? <Mail className="w-4 h-4" /> : <MessageSquare className="w-4 h-4" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  <span className="font-bold uppercase tracking-wider">{m.channel}</span>
                  <span>·</span>
                  <span>{new Date(m.created_at).toLocaleString()}</span>
                  <span>·</span>
                  <span
                    className={`status-pill ${m.status === "failed" ? "status-rejected" : "status-accepted"}`}
                    data-testid={`msg-status-${m.id}`}
                    title={m.status === "failed" ? (m.error || "Delivery failed") : (m.provider_id ? `Provider id: ${m.provider_id}` : "")}
                  >
                    {m.status}
                  </span>
                  {m.provider && m.provider !== "mock" && (
                    <>
                      <span>·</span>
                      <span className="text-[10px] uppercase tracking-wider text-slate-400">via {m.provider}</span>
                    </>
                  )}
                </div>
                <div className="mt-1 text-sm">
                  <span className="font-semibold text-slate-900">To:</span> <span className="text-slate-700">{m.to}</span>
                  {m.subject && <> · <span className="font-semibold text-slate-900">Subj:</span> <span className="text-slate-700">{m.subject}</span></>}
                </div>
                <div className="mt-1 text-sm text-slate-600 whitespace-pre-wrap line-clamp-3">{m.message}</div>
                {m.status === "failed" && m.error && (
                  <div className="mt-1 text-xs text-red-600 font-semibold" data-testid={`msg-error-${m.id}`}>
                    Delivery failed: {m.error}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
